import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/massage-energetique-toulouse")({
  head: () => ({
    meta: [
      { title: "Massage énergétique à Toulouse — Rénergescence" },
      { name: "description", content: "Massage énergétique à Toulouse : bioénergétique corporelle, relâchement profond et libération des tensions. Cabinet Rénergescence — sur rendez-vous." },
      { property: "og:title", content: "Massage énergétique à Toulouse — Rénergescence" },
      { property: "og:description", content: "Massage bioénergétique au cabinet Rénergescence à Toulouse." },
      { property: "og:url", content: "/massage-energetique-toulouse" },
    ],
    links: [{ rel: "canonical", href: "https://renergescence.com/massage-energetique-toulouse" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          name: "Massage énergétique",
          serviceType: "Massage bien-être énergétique",
          description: "Massage énergétique alliant techniques manuelles et travail énergétique pour relâcher les tensions et rééquilibrer le corps.",
          provider: {
            "@type": "LocalBusiness",
            name: "Rénergescence",
            address: {
              "@type": "PostalAddress",
              streetAddress: "3 rue Ledru-Rollin",
              addressLocality: "Toulouse",
              postalCode: "31300",
              addressCountry: "FR",
            },
          },
          areaServed: { "@type": "City", name: "Toulouse" },
          offers: { "@type": "Offer", price: "75", priceCurrency: "EUR" },
        }),
      },
    ],
  }),
  component: Page,
});

const bienfaits = [
  { t: "Libération des tensions", d: "Relâchement musculaire profond et apaisement du système nerveux." },
  { t: "Circulation énergétique", d: "Stimulation de la circulation des fluides et de l'énergie vitale." },
  { t: "Récupération physique", d: "Idéal après l'effort, en période de stress intense ou de fatigue." },
  { t: "Ancrage & sérénité", d: "Reconnexion au corps, retour au calme intérieur durable." },
];

function Page() {
  return (
    <>
      <section className="pt-20 pb-12 md:pt-28">
        <div className="mx-auto max-w-3xl px-6 text-center">
          <p className="eyebrow">Bioénergétique corporelle</p>
          <h1 className="mt-5 font-display text-4xl font-light italic md:text-6xl">Massage énergétique à Toulouse</h1>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed md:text-lg" style={{ color: "var(--color-muted-foreground)" }}>
            Une approche manuelle qui allie technique de massage et travail énergétique, pour relâcher les tensions et réharmoniser le corps en profondeur.
          </p>
          <Link to="/contact" className="mt-8 inline-block rounded-full px-8 py-4 text-sm font-medium text-white" style={{ backgroundColor: "#7A8A76" }}>
            Réserver ma séance
          </Link>
        </div>
      </section>

      <section className="py-16 md:py-20" style={{ backgroundColor: "var(--color-surface)" }}>
        <div className="mx-auto max-w-[1100px] px-6">
          <h2 className="text-center font-display text-3xl font-light md:text-4xl">Les bienfaits physiques du massage énergétique</h2>
          <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
            {bienfaits.map((b) => (
              <div key={b.t} className="rounded-3xl border bg-white p-6" style={{ borderColor: "#e8e0d8" }}>
                <h3 className="font-display text-lg" style={{ color: "#2D2B28" }}>{b.t}</h3>
                <p className="mt-3 text-[14px] leading-relaxed" style={{ color: "var(--color-text)" }}>{b.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="mx-auto max-w-[820px] px-6">
          <h2 className="font-display text-3xl font-light md:text-4xl">Le déroulé d'une séance</h2>
          <ol className="mt-8 space-y-6">
            <li><strong>1. Échange initial.</strong> Un temps d'écoute pour cerner vos besoins du jour et adapter la séance.</li>
            <li><strong>2. Travail manuel.</strong> Manœuvres profondes ou enveloppantes selon les zones de tension identifiées.</li>
            <li><strong>3. Soin énergétique.</strong> Imposition des mains pour soutenir la libération des blocages.</li>
            <li><strong>4. Retour au calme.</strong> Un moment d'intégration pour ancrer les bienfaits de la séance.</li>
          </ol>
          <div className="mt-10 flex flex-wrap gap-3">
            <Link to="/prestations" hash="massages" className="rounded-full border px-5 py-2 text-sm" style={{ borderColor: "#7A8A76", color: "var(--color-sage-text)" }}>Voir toutes les techniques manuelles</Link>
              <Link to="/tarifs" className="rounded-full px-5 py-2 text-sm text-white" style={{ backgroundColor: "#7A8A76" }}>Voir les tarifs</Link>
          </div>
        </div>
      </section>
    </>
  );
}